import { getAPIN8N } from "@/services/Api/n8nApiConfig";
import { showToast } from "@/utils";

const ALLOWED_HOSTS = [
  "prdc-n8n-webhook.barte.com",
  "comprovante-pagamento.s3.us-east-1.amazonaws.com",
];

export function usePaymentReceipt() {
  const baseUrl = "/payment-receipt";

  async function postPaymentReceipt(uuid: string) {
    const api = getAPIN8N();
    const { data } = await api.post(`${baseUrl}`, {
      uuid: uuid,
      download: true,
    });
    if (data.url) {
      const parsed = new URL(data.url);
      const isAllowed =
        parsed.protocol === "https:" &&
        ALLOWED_HOSTS.includes(parsed.hostname);
      if (isAllowed) {
        window.location.assign(data.url);
      } else {
        throw new Error("Erro ao gerar o comprovante");
      }
    }
  }

  async function handleDownloadReceipt(uuid: string, onClose?: () => void) {
    try {
      await postPaymentReceipt(uuid);
      showToast({
        message: "Download do comprovante feito com sucesso!",
        type: "success",
      });
    } catch (error) {
      showToast({
        message: "Erro ao fazer download do comprovante, tente novamente",
        type: "error",
      });
    } finally {
      if (onClose) {
        onClose();
      }
    }
  }

  return {
    handleDownloadReceipt,
  };
}
